// client/src/utils/bellSchedule.generated.js
//
// GENERATED - do not edit by hand.
//
// Copied from packages/core/src/portal/admin.js by tools/sync-shared.py. Edit the core file and re-run that
// script; `node tools/marks-sheet-conformance.mjs` asserts this copy has not
// drifted from it.
//
// The phone imports the original. The web cannot (packages/core is outside
// client/src, and the CRA build will not resolve it), so it gets this. They must
// stay identical - a rule that exists twice and differs is the whole class of
// bug these files were written to end.
//
// The grid a class's week is drawn on. THREE copies of this arithmetic
// exist -- core for the phone, this one for the web, and a CommonJS twin
// at server/services/timetable/bellSchedule.js the solver runs on. A
// break consumes real time, so everything after it shifts; a copy that
// shifts differently puts the same class in two different afternoons.
// tools/timetable-conformance.mjs runs all three over the same configs.

const toMin = (hhmm) => {
  const m = /^(\d{1,2}):(\d{2})$/.exec(String(hhmm || '').trim());
  return m ? (Number(m[1]) * 60 + Number(m[2])) : NaN;
};
const toHHMM = (mins) => `${String(Math.floor(mins / 60)).padStart(2, '0')}:${String(mins % 60).padStart(2, '0')}`;

/**
 * The day's slots: periods interleaved with breaks.
 * -> [{ type: 'period'|'break', start, end, label? }]
 */
export function buildDaySlots(config = {}) {
  const cfg = { ...DEFAULT_DAY_CONFIG, ...config };
  const slots = [];
  const startMinutes = toMin(cfg.dayStart);
  const endMinutes = toMin(cfg.dayEnd);
  const periodDuration = Number(cfg.periodMinutes) || 0;
  if (!Number.isFinite(startMinutes) || !Number.isFinite(endMinutes)) return slots;
  if (endMinutes <= startMinutes || periodDuration <= 0) return slots;

  const breaks = [cfg.shortBreak, cfg.longBreak]
    .filter((b) => Number(b?.periodsBefore) > 0 && Number(b?.durationMinutes) > 0)
    .sort((a, b) => a.periodsBefore - b.periodsBefore);

  let cursor = startMinutes;
  let periodCounter = 0;
  let breakIndex = 0;

  while (cursor < endMinutes) {
    const nextBreak = breaks[breakIndex];
    if (nextBreak && periodCounter === nextBreak.periodsBefore) {
      const breakEnd = Math.min(cursor + Number(nextBreak.durationMinutes), endMinutes);
      slots.push({
        type: 'break',
        label: nextBreak.label || null,
        start: toHHMM(cursor),
        end: toHHMM(breakEnd),
      });
      cursor = breakEnd;
      breakIndex += 1;
      continue;
    }
    const periodEnd = Math.min(cursor + periodDuration, endMinutes);
    slots.push({ type: 'period', start: toHHMM(cursor), end: toHHMM(periodEnd) });
    cursor = periodEnd;
    periodCounter += 1;
  }
  return slots;
}

/**
 * Which days the week runs over. weekStart/weekEnd are ISO numbers, so a school
 * that teaches Monday to Friday gets 1..5 and one that includes Saturday 1..6.
 */
export function weekDays(weekStart = 1, weekEnd = 5) {
  const a = Math.max(1, Math.min(6, Number(weekStart) || 1));
  const b = Math.max(a, Math.min(6, Number(weekEnd) || 5));
  const out = [];
  for (let d = a; d <= b; d += 1) out.push(d);
  return out;
}

/**
 * THE DAY IS GENERATED, NOT TYPED. This is the shape of the whole timetable
 * feature and it is easy to miss: a school does not enter a start and end time
 * for every period. It configures the day once — when teaching starts and ends,
 * how long a period is, and where the breaks fall — and the periods are
 * generated from that. Slots are then filled against the generated periods.
 *
 * Asking a user to type 08:00 and 08:55 on every slot, as a naive port does,
 * both multiplies the work and lets periods drift out of alignment with each
 * other, which is exactly what a timetable exists to prevent.
 *
 * Breaks are placed by COUNT, not by clock: "after 3 periods, 15 minutes". The
 * break consumes real time, so everything after it shifts, and a school that
 * lengthens its break does not have to retype the afternoon.
 *
 * Ported from the web's buildSlotsWithBreaks so the two generate identical days.
 */
export const DEFAULT_DAY_CONFIG = {
  dayStart: '08:00',
  dayEnd: '17:00',
  periodMinutes: 60,
  shortBreak: { periodsBefore: 3, durationMinutes: 15 },
  longBreak: { periodsBefore: 6, durationMinutes: 45 },
};
